import { makeAutoObservable, observable } from 'mobx'
import { Editor, TLStoreSnapshot, TLStoreWithStatus, createTLStore } from '@tldraw/tldraw'
import { shapeUtils } from 'components/VisualStudioPlayground/VisualEditor/VisualEditor'
import { getSnapshotFontFamilies } from 'components/VisualStudioPlayground/VisualEditor/helpers'
import { RootStore } from 'stores/RootStore'

export class DesignContentPreviewStore {
  rootStore: RootStore
  editor: Editor
  store: TLStoreWithStatus = { status: 'loading' }

  constructor(rootStore: RootStore, snapshot: TLStoreSnapshot) {
    makeAutoObservable(this, {
      editor: observable.ref,
      store: observable.ref,
    })
    this.rootStore = rootStore

    this.editor = new Editor({
      store: createTLStore({}),
      shapeUtils: [],
      tools: [],
      getContainer: () => document.createElement('div'),
    })

    this.loadSnapshot(snapshot)
  }

  setEditor = (editor: Editor) => {
    this.editor = editor
  }

  setStore = (store: TLStoreWithStatus) => {
    this.store = store
  }

  loadSnapshot = async (snapshot: TLStoreSnapshot) => {
    this.setStore({ status: 'loading' })
    await this.preloadFonts(snapshot)
    const newStore = createTLStore({ shapeUtils })
    newStore.loadSnapshot(snapshot)
    this.setStore({ status: 'synced-local', store: newStore })
  }

  preloadFonts = async (snapshot: TLStoreSnapshot) => {
    return Promise.all(getSnapshotFontFamilies(snapshot).map((family) => this.rootStore.fonts.get(family)?.load()))
  }
}
